import { render } from "./HomePortfolioItem.vue?vue&type=template&id=4008cece&scoped=true"
import script from "./HomePortfolioItem.vue?vue&type=script&lang=js"
export * from "./HomePortfolioItem.vue?vue&type=script&lang=js"

import "./HomePortfolioItem.vue?vue&type=style&index=0&id=4008cece&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4008cece"]])

export default __exports__